import React from 'react'
import { connect } from 'react-redux'
import { editSets } from "../../actions/settings"
import { CompactPicker } from 'react-color'
import DeleteConfirmation from '../ui/DeleteConfirmation'
import SettingsItemForm from './SettingsItemForm'

class SetsSttsItem extends SettingsItemForm {

  componentWillMount(){
    this.setState({
      editing: false,
      delConf: false,
      colorPick: false,
      data: this.props.data,
      errors: {}
    });
  }

  selectColor = () => {
    this.setState({colorPick:true});
  }

  applyColor = color => {
    this.setState({
      data:{
        ...this.state.data,
        stts_color_id:color.hex
      },
      colorPick:false
    });
  }

  cancelColorPick = () => {
    this.setState({
      data:{
        ...this.state.data,
        stts_color_id:this.props.data.stts_color_id
      },
      colorPick:false
    });
  }

  render() {
    const { data } = this.props;
    const { data: nData, errors } = this.state;

    const delConf = this.state.delConf ?
      <DeleteConfirmation
        onDelete={this.deleteItem}
        onCancel={this.toggleDelConf}
      />
      :'';
    const colorPick = this.state.colorPick ?
      <div style={{position:'absolute',zIndex:2,right:'15px'}}>
        <CompactPicker
          color={nData.stts_color_id}
          onChangeComplete={ this.applyColor }
        />
      </div>
      :'';

    if(this.state.editing){
      return(
        <tr>
          <td>
          {delConf}
          {colorPick}
            <div className="form-group">
              <input type="text"
                className="form-control"
                value={nData.stts_desc}
                name="stts_desc"
                onChange={this.updateInput}
                placeholder="Название"
              />
            </div>
            <div className="form-inline">
              <button  type="button" className="btn btn-success"
                onClick={this.saveItem} title="Сохранить">
                <span className="glyphicon glyphicon-save"></span>
              </button>{" "}
              <button type="button" className="btn btn-default"
                onClick={this.cancelEditing} title="Отменить">
                <span className="glyphicon glyphicon-remove"></span>
              </button>{" "}
              <button type="button" className="btn btn-danger"
                onClick={this.toggleDelConf} title="Удалить">
                <span className="glyphicon glyphicon-trash"></span>
              </button>
            </div>
            {errors.form && <div className="alert alert-danger">{errors.form}</div>}
          </td>
          <td>
            <input
              type="checkbox"
              checked={nData.stts_rep}
              name="stts_rep"
              onChange={this.handleChBox}
            />
          </td>
          <td>
            <input
              type="checkbox"
              checked={nData.stts_locked}
              name="stts_locked"
              onChange={this.handleChBox}
            />
          </td>
          <td
            style={{
              backgroundColor:nData.stts_color_id,
              cursor:'pointer'
            }}
            onClick={this.selectColor}
          >
          </td>
        </tr>
      );
    }
    else{
      return (
        <tr onClick={this.startEditing}>
          <td>{data.stts_desc}</td>
          <td>{data.stts_rep ? '\u2713' : ''}</td>
          <td>{data.stts_locked ? '\u2713' : ''}</td>
          <td style={{backgroundColor:data.stts_color_id}}></td>
        </tr>
      );
    }

  }
}

export default connect(null, { editSets })(SetsSttsItem);



// WEBPACK FOOTER //
// ./src/components/settings/SetsSttsItem.js